<template>
  <div
    class="esport-match-card"
    :class="[
      variant,
      {
        done: match.status === 'selesai',
        bye: match.status === 'bye',
        placeholder: match.isPlaceholder,
      },
    ]"
    :data-match-id="match.id"
    :data-placeholder="match.isPlaceholder ? 'true' : 'false'"
  >
    <div class="match-number">
      <span
        class="match-label"
        :class="{ 'card-draggable': bisaGeserKartu, 'card-drop-hover': cardDropHover }"
        :draggable="bisaGeserKartu"
        :title="
          bisaGeserKartu ? 'Seret untuk menukar posisi kartu ini dengan kartu lain' : ''
        "
        @dragstart="onCardHeaderDragStart"
        @dragend="onCardHeaderDragEnd"
        @dragenter.prevent="onCardHeaderDragEnter"
        @dragover.prevent
        @dragleave="cardDropHover = false"
        @drop.prevent="onCardHeaderDrop"
      >
        <v-icon v-if="bisaGeserKartu" x-small class="card-drag-handle">mdi-drag</v-icon>
        {{ match.isPlaceholder ? "Match ?" : `Match ${match.urutan}` }}
      </span>

      <v-menu
        v-if="bisaDijadwalkan"
        v-model="menuJadwalOpen"
        :close-on-content-click="false"
        offset-y
        left
      >
        <template #activator="{ on, attrs }">
          <button
            type="button"
            class="jadwal-trigger"
            :class="{ terjadwal: !!match.jadwal_mulai }"
            v-bind="attrs"
            v-on="on"
          >
            <v-icon x-small>{{
              match.jadwal_mulai ? "mdi-timer-outline" : "mdi-timer-plus-outline"
            }}</v-icon>
            {{ jadwalRingkas }}
          </button>
        </template>

        <div class="jadwal-menu">
          <div class="jadwal-menu-title">Atur Countdown Match</div>

          <div class="jadwal-menu-status">{{ jadwalStatusText }}</div>

          <div class="jadwal-quick-row">
            <v-btn x-small depressed @click="$emit('set-jadwal', { menit: 5 })">
              5 mnt
            </v-btn>
            <v-btn x-small depressed @click="$emit('set-jadwal', { menit: 10 })">
              10 mnt
            </v-btn>
            <v-btn x-small depressed @click="$emit('set-jadwal', { menit: 15 })">
              15 mnt
            </v-btn>
            <v-btn x-small depressed @click="$emit('set-jadwal', { menit: 30 })">
              30 mnt
            </v-btn>
          </div>

          <div class="jadwal-custom-row">
            <input
              type="number"
              min="0"
              class="jadwal-menit-input"
              v-model="menitCustom"
              placeholder="menit"
            />
            <v-btn
              x-small
              depressed
              class="jadwal-set-btn"
              :disabled="menitCustom === '' || Number(menitCustom) < 0"
              @click="$emit('set-jadwal', { menit: Number(menitCustom) })"
            >
              Set
            </v-btn>
          </div>

          <v-btn
            x-small
            depressed
            block
            class="jadwal-live-btn"
            @click="$emit('set-jadwal', { menit: 0 })"
          >
            <v-icon left x-small>mdi-play-circle-outline</v-icon>
            Live Sekarang
          </v-btn>

          <v-btn
            v-if="match.jadwal_mulai"
            x-small
            text
            block
            class="jadwal-clear-btn"
            @click="$emit('set-jadwal', { clear: true })"
          >
            Hapus Jadwal
          </v-btn>
        </div>
      </v-menu>
    </div>

    <div
      class="match-row"
      :class="{
        winner:
          !match.isPlaceholder &&
          match.pemenang_id &&
          match.pemenang_id === match.peserta1_id,
        'drop-hover': dropHoverSlot === 'peserta1',
      }"
      :draggable="draggable1"
      @dragstart="onDragStart('peserta1', $event)"
      @dragend="onDragEnd"
      @dragenter.prevent="dropHoverSlot = 'peserta1'"
      @dragover.prevent
      @dragleave="dropHoverSlot = null"
      @drop.prevent="onDrop('peserta1')"
    >
      <div class="player-info">
        <span
          v-if="
            !match.isPlaceholder &&
            match.pemenang_id &&
            match.pemenang_id === match.peserta1_id
          "
          class="winner-icon"
        >
          <v-icon x-small>mdi-crown</v-icon>
        </span>

        <v-icon v-if="draggable1" x-small class="drag-handle">mdi-drag-vertical</v-icon>

        <span class="match-nama">{{ nama1 }}</span>
      </div>

      <input
        v-if="showInputs"
        type="number"
        min="0"
        class="skor-input"
        v-model="localInput.skor1"
      />
      <span v-else-if="match.status === 'bye'" class="bye-tag">BYE</span>
      <span v-else-if="match.isPlaceholder" class="tbd-tag">TBD</span>
    </div>

    <div class="player-divider"></div>

    <div
      class="match-row"
      :class="{
        winner:
          !match.isPlaceholder &&
          match.pemenang_id &&
          match.pemenang_id === match.peserta2_id,
        'drop-hover': dropHoverSlot === 'peserta2',
      }"
      :draggable="draggable2"
      @dragstart="onDragStart('peserta2', $event)"
      @dragend="onDragEnd"
      @dragenter.prevent="dropHoverSlot = 'peserta2'"
      @dragover.prevent
      @dragleave="dropHoverSlot = null"
      @drop.prevent="onDrop('peserta2')"
    >
      <div class="player-info">
        <span
          v-if="
            !match.isPlaceholder &&
            match.pemenang_id &&
            match.pemenang_id === match.peserta2_id
          "
          class="winner-icon"
        >
          <v-icon x-small>mdi-crown</v-icon>
        </span>

        <v-icon v-if="draggable2" x-small class="drag-handle">mdi-drag-vertical</v-icon>

        <span class="match-nama">
          <template v-if="!match.isPlaceholder && match.peserta2_id">{{
            nama2
          }}</template>
          <template v-else-if="match.isPlaceholder">{{ nama2 }}</template>
          <template v-else>—</template>
        </span>
      </div>

      <input
        v-if="showInputs"
        type="number"
        min="0"
        class="skor-input"
        v-model="localInput.skor2"
      />
      <span v-else-if="match.isPlaceholder" class="tbd-tag">TBD</span>
    </div>

    <div class="match-actions" v-if="showInputs">
      <div class="pemenang-row">
        <button
          type="button"
          class="pemenang-btn"
          :class="{
            active: !!match.pemenang_id && match.pemenang_id === match.peserta1_id,
          }"
          :title="`Tetapkan ${nama1} sebagai pemenang`"
          @click="$emit('tentukan-pemenang', match.peserta1_id)"
        >
          <v-icon x-small>mdi-trophy-outline</v-icon>
          <span class="pemenang-btn-nama">{{ nama1 }}</span>
        </button>
        <button
          type="button"
          class="pemenang-btn"
          :class="{
            active: !!match.pemenang_id && match.pemenang_id === match.peserta2_id,
          }"
          :title="`Tetapkan ${nama2} sebagai pemenang`"
          @click="$emit('tentukan-pemenang', match.peserta2_id)"
        >
          <v-icon x-small>mdi-trophy-outline</v-icon>
          <span class="pemenang-btn-nama">{{ nama2 }}</span>
        </button>
      </div>

      <div class="skor-actions-row">
        <v-btn
          x-small
          depressed
          class="simpan-btn"
          :loading="localInput.saving"
          @click="$emit('simpan')"
        >
          <v-icon left x-small>mdi-content-save-outline</v-icon>
          {{ match.status === "selesai" ? "Revisi Skor" : "Simpan Skor" }}
        </v-btn>
      </div>

      <div v-if="match.status === 'selesai'" class="rematch-row">
        <v-btn x-small text block class="rematch-btn" @click="$emit('rematch')">
          <v-icon left x-small>mdi-restart</v-icon>
          Rematch
        </v-btn>
      </div>
    </div>

    <div v-if="bisaMundur" class="rematch-row">
      <v-btn x-small text block class="mundur-btn" @click="$emit('mundur')">
        <v-icon left x-small>mdi-undo-variant</v-icon>
        Mundurkan Babak
      </v-btn>
    </div>
  </div>
</template>

<script setup>
import { computed, ref } from "vue";

const props = defineProps({
  match: { type: Object, required: true },
  nama1: { type: String, default: "—" },
  nama2: { type: String, default: "—" },
  inputState: { type: Object, default: null },
  variant: { type: String, default: "normal" },
});

const emit = defineEmits([
  "simpan",
  "drag-start",
  "drag-end",
  "drop",
  "set-jadwal",
  "tentukan-pemenang",
  "rematch",
  "mundur",
  "card-drag-start",
  "card-drag-end",
  "card-drop",
]);

const bisaMundur = computed(() => {
  const m = props.match;
  if (!m || m.isPlaceholder) return false;
  if (m.ronde >= 900) return false;
  if (m.status === "selesai") return false;
  return !!(m.asal_match1_id || m.asal_match2_id);
});

const localInput = computed(
  () => props.inputState || { skor1: "", skor2: "", editing: false, saving: false }
);

const showInputs = computed(
  () =>
    !props.match.isPlaceholder && !!props.match.peserta1_id && !!props.match.peserta2_id
);

const bisaDijadwalkan = computed(
  () =>
    !props.match.isPlaceholder &&
    props.match.status === "menunggu" &&
    !!props.match.peserta1_id &&
    !!props.match.peserta2_id
);

const menuJadwalOpen = ref(false);
const menitCustom = ref("");

const jadwalRingkas = computed(() => {
  if (!props.match.jadwal_mulai) return "Jadwal";
  const t = new Date(String(props.match.jadwal_mulai).replace(" ", "T"));
  if (Number.isNaN(t.getTime())) return "Jadwal";
  const sudahLewat = t.getTime() <= Date.now();
  const jam = String(t.getHours()).padStart(2, "0");
  const menit = String(t.getMinutes()).padStart(2, "0");
  return sudahLewat ? "Live" : `${jam}:${menit}`;
});

const jadwalStatusText = computed(() => {
  if (!props.match.jadwal_mulai) {
    return "Belum dijadwalkan";
  }
  const t = new Date(String(props.match.jadwal_mulai).replace(" ", "T"));
  if (Number.isNaN(t.getTime())) return "Belum dijadwalkan.";
  const sudahLewat = t.getTime() <= Date.now();
  if (sudahLewat) return "Sedang Live sekarang di layar client.";
  const jam = String(t.getHours()).padStart(2, "0");
  const menit = String(t.getMinutes()).padStart(2, "0");
  return `Dijadwalkan mulai pukul ${jam}:${menit} (countdown berjalan di client).`;
});

const draggable1 = computed(
  () =>
    !props.match.isPlaceholder &&
    (props.match.status === "menunggu" || props.match.status === "bye") &&
    !!props.match.peserta1_id
);
const draggable2 = computed(
  () =>
    !props.match.isPlaceholder &&
    props.match.status === "menunggu" &&
    !!props.match.peserta2_id
);

const dropHoverSlot = ref(null);

const bisaGeserKartu = computed(
  () => !props.match.isPlaceholder && props.match.ronde < 900
);
const cardDropHover = ref(false);

function onCardHeaderDragStart(event) {
  if (event && event.dataTransfer) {
    event.dataTransfer.effectAllowed = "move";
    try {
      event.dataTransfer.setData(
        "application/x-card-move",
        JSON.stringify({ matchId: props.match.id })
      );
    } catch (e) {
    }
  }
  emit("card-drag-start", { matchId: props.match.id });
}

function onCardHeaderDragEnter() {
  if (bisaGeserKartu.value) cardDropHover.value = true;
}

function onCardHeaderDragEnd() {
  cardDropHover.value = false;
  emit("card-drag-end");
}

function onCardHeaderDrop() {
  cardDropHover.value = false;
  emit("card-drop", { matchId: props.match.id });
}

function onDragStart(slot, event) {
  if (event && event.dataTransfer) {
    event.dataTransfer.effectAllowed = "move";
    try {
      event.dataTransfer.setData(
        "text/plain",
        JSON.stringify({ matchId: props.match.id, slot, ronde: props.match.ronde })
      );
    } catch (e) {
    }
  }
  emit("drag-start", { matchId: props.match.id, slot, ronde: props.match.ronde });
}

function onDragEnd() {
  dropHoverSlot.value = null;
  emit("drag-end");
}

function onDrop(slot) {
  dropHoverSlot.value = null;
  emit("drop", { matchId: props.match.id, slot, ronde: props.match.ronde });
}
</script>

<style scoped>
.esport-match-card {
  position: relative;
  width: 250px;
  min-height: 122px;
  padding: 9px;
  background: rgba(255, 255, 255, 0.98);
  border: 1px solid #dbe4ea;
  border-radius: 14px;
  box-shadow: 0 4px 12px rgba(15, 23, 42, 0.045), 0 1px 2px rgba(15, 23, 42, 0.035);
  transition: transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease;
}

.esport-match-card.small {
  width: 220px;
  min-height: 108px;
}

.esport-match-card:hover {
  transform: translateY(-2px);
  border-color: rgba(1, 140, 116, 0.35);
  box-shadow: 0 9px 25px rgba(15, 23, 42, 0.08), 0 2px 5px rgba(15, 23, 42, 0.04);
}

.esport-match-card.done {
  border-color: rgba(1, 140, 116, 0.38);
  background: linear-gradient(
    145deg,
    rgba(1, 140, 116, 0.045),
    rgba(255, 255, 255, 0.98)
  );
}

.esport-match-card.bye {
  opacity: 0.72;
  background: #f8fafc;
}

.esport-match-card.placeholder {
  opacity: 0.6;
  border-style: dashed !important;
  box-shadow: none;
  background: repeating-linear-gradient(
    135deg,
    #f8fafc,
    #f8fafc 8px,
    #f1f5f9 8px,
    #f1f5f9 16px
  );
}

.esport-match-card.placeholder:hover {
  transform: none;
  border-color: #dbe4ea;
}

.esport-match-card.final {
  border-color: rgba(217, 119, 6, 0.3);
  background: linear-gradient(145deg, #fffdf7, #ffffff);
}

.match-number {
  height: 18px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 5px;
  font-size: 8px;
  font-weight: 800;
  color: #94a3b8;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.match-label {
  display: inline-flex;
  align-items: center;
  gap: 2px;
}

.match-label.card-draggable {
  cursor: grab;
  border-radius: 6px;
  padding: 1px 4px;
  margin: -1px -4px;
}

.match-label.card-draggable:active {
  cursor: grabbing;
}

.match-label.card-draggable:hover {
  background: rgba(1, 140, 116, 0.08);
  color: #018c74;
}

.match-label.card-drop-hover {
  outline: 2px dashed #018c74;
  outline-offset: 1px;
  background: rgba(1, 140, 116, 0.12);
  color: #018c74;
}

.card-drag-handle {
  color: #94a3b8;
}

.match-label.card-draggable:hover .card-drag-handle,
.match-label.card-drop-hover .card-drag-handle {
  color: #018c74;
}

.jadwal-trigger {
  display: inline-flex;
  align-items: center;
  gap: 2px;

  padding: 2px 6px;
  border: 1px solid #e2e8f0;
  border-radius: 999px;
  background: #f8fafc;

  font-size: 7px;
  font-weight: 850;
  letter-spacing: 0.3px;
  text-transform: none;
  color: #64748b;
  cursor: pointer;
}

.jadwal-trigger:hover {
  border-color: #018c74;
  color: #018c74;
}

.jadwal-trigger.terjadwal {
  border-color: rgba(217, 119, 6, 0.4);
  background: rgba(217, 119, 6, 0.08);
  color: #b5720a;
}

.jadwal-menu {
  width: 210px;
  padding: 10px;
  background: #ffffff;
}

.jadwal-menu-title {
  font-size: 10px;
  font-weight: 850;
  color: #334155;
  margin-bottom: 4px;
}

.jadwal-menu-status {
  font-size: 9px;
  line-height: 1.4;
  color: #64748b;
  margin-bottom: 8px;
}

.jadwal-quick-row {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 4px;
  margin-bottom: 6px;
}

.jadwal-quick-row .v-btn {
  min-width: 0 !important;
  padding: 0 4px !important;
  font-size: 8px !important;
  text-transform: none !important;
}

.jadwal-custom-row {
  display: flex;
  gap: 4px;
  margin-bottom: 6px;
}

.jadwal-menit-input {
  flex: 1;
  min-width: 0;
  height: 26px;
  padding: 0 6px;
  border: 1px solid #cbd5e1;
  border-radius: 6px;
  font-size: 10px;
  text-align: center;
}

.jadwal-set-btn {
  text-transform: none !important;
  background: #018c74 !important;
  color: #fff !important;
}

.jadwal-live-btn {
  margin-bottom: 4px;
  text-transform: none !important;
  background: #b5720a !important;
  color: #fff !important;
}

.jadwal-clear-btn {
  text-transform: none !important;
  color: #94a3b8 !important;
}

.match-row {
  min-height: 34px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 5px 7px;
  border-radius: 8px;
  background: #f8fafc;
  border: 1px solid transparent;
}

.match-row.winner {
  background: rgba(1, 140, 116, 0.09);
  border-color: rgba(1, 140, 116, 0.14);
}

.match-row.winner .match-nama {
  color: #018c74;
  font-weight: 800;
}

.match-row[draggable="true"] {
  cursor: grab;
}

.match-row[draggable="true"]:active {
  cursor: grabbing;
}

.match-row.drop-hover {
  outline: 2px dashed #018c74;
  outline-offset: -2px;
  background: rgba(1, 140, 116, 0.1);
}

.player-info {
  min-width: 0;
  flex: 1;
  display: flex;
  align-items: center;
  gap: 5px;
}

.drag-handle {
  color: #94a3b8;
  flex: 0 0 auto;
}

.match-nama {
  min-width: 0;
  display: block;
  font-size: 11px;
  font-weight: 600;
  color: #334155;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.winner-icon {
  width: 17px;
  height: 17px;
  flex: 0 0 17px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 5px;
  color: #d97706;
  background: #fffbeb;
}

.player-divider {
  height: 1px;
  margin: 2px 8px;
  background: #e8edf1;
}

.skor-input {
  width: 42px;
  height: 27px;
  flex: 0 0 42px;
  padding: 0 4px;
  text-align: center;
  border: 1px solid #cbd5e1;
  border-radius: 7px;
  outline: none;
  font-size: 12px;
  font-weight: 850;
  color: #1e293b;
  background: #ffffff;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.skor-input:focus {
  border-color: #018c74;
  box-shadow: 0 0 0 3px rgba(1, 140, 116, 0.1);
}

.skor-input:disabled {
  background: #f1f5f9;
  color: #64748b;
  cursor: not-allowed;
}

.skor-input::-webkit-outer-spin-button,
.skor-input::-webkit-inner-spin-button {
  margin: 0;
  -webkit-appearance: none;
}

.skor-input[type="number"] {
  appearance: textfield;
}

.bye-tag,
.tbd-tag {
  flex: 0 0 auto;
  font-size: 8px;
  font-weight: 850;
  color: #64748b;
  background: #eef2f7;
  border: 1px solid #e2e8f0;
  padding: 4px 7px;
  border-radius: 6px;
  letter-spacing: 0.4px;
}

.tbd-tag {
  color: #94a3b8;
}

.match-actions {
  display: flex;
  flex-direction: column;
  gap: 5px;
  margin-top: 5px;
  padding: 0 2px;
}

.pemenang-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 4px;
}

.pemenang-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 3px;
  min-width: 0;
  height: 22px;
  padding: 0 4px;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  background: #f8fafc;
  color: #64748b;
  font-size: 8px;
  font-weight: 800;
  cursor: pointer;
  transition: border-color 0.15s ease, color 0.15s ease, background 0.15s ease;
}

.pemenang-btn:hover {
  border-color: #d97706;
  color: #b5720a;
}

.pemenang-btn.active {
  border-color: #d97706;
  background: #fffbeb;
  color: #b5720a;
}

.pemenang-btn-nama {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.skor-actions-row {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  min-height: 26px;
}

.rematch-row {
  margin-top: 2px;
}

.rematch-btn {
  color: #dc2626 !important;
  text-transform: none !important;
  font-size: 9px !important;
  font-weight: 700 !important;
  border: 1px dashed rgba(220, 38, 38, 0.3) !important;
  border-radius: 7px !important;
}

.rematch-btn:hover {
  background: #fff5f5 !important;
  border-color: rgba(220, 38, 38, 0.5) !important;
}

.simpan-btn {
  min-width: 70px;
  background: #018c74 !important;
  color: #ffffff !important;
  text-transform: none !important;
  border-radius: 7px !important;
  font-size: 9px !important;
  font-weight: 700 !important;
  box-shadow: 0 3px 8px rgba(1, 140, 116, 0.18) !important;
}

.simpan-btn:hover {
  background: #017560 !important;
}

.revisi-btn {
  color: #64748b !important;
  text-transform: none !important;
  font-size: 10px !important;
}

.revisi-btn:hover {
  color: #018c74 !important;
}
</style>
